export const hotels = [
  {
    logo: "/shangrila.png",
    name: "Shangri-la Makati",
    description:
      "The hotel is known for its timeless elegance and legendary brand of service, supported by inventive and on-trend destination dining experiences, and the most flexible banqueting spaces in Metro Manila.",
    address: "Ayala Avenue corner Makati Avenue, Makati City 1200 Philippines",
    phone: "(63 2) 8813 8888",
    email: "makati@shangri-la.com",
    promo: "#",
  },
  {
    logo: "/Holidayinn.png",
    name: "Holiday Inn & Suites Makati",
    description:
      "Holiday Inn & Suites Makati is a 5-star, family-friendly hotel in the vibrant Makati Central Business & Entertainment District.",
    address:
      "Glorietta Mall, Palm Drive, Ayala Center, Makati 1224 Philippines",
    phone: "+63 2909 0888",
    email: "hisuites.makati@ihg.com",
    promo: "#",
  },
  {
    logo: "/dusit.png",
    name: "Dusit Thani Manila",
    description:
      "Luxury, heritage, and comfort combine gracefully at Dusit Thani Manila, a 5-star hotel in Makati, situated in the heart of the financial capital.",
    address: "Ayala Centre, 1223 Makati City Metro Manila, Philippines",
    phone: "+63 (2) 7238 8888",
    email: "dtmn@dusit.com",
    promo: "#",
  },
  {
    logo: "/askot.png",
    name: "Ascott Makati",
    description:
      "At the end of an exciting day, retire to the luxury residence to rejuvenate. Ascott Makati offers global travelers the comforts and little lavishes that makes us their home of choice away from home.",
    address: "Glorietta 4, Ayala Center, Makati City 1224, Philippines",
    phone: "+63 2909 0888",
    email: "hisuites.makati@ihg.com",
    promo: "#",
  },
  {
    logo: "/seda.png",
    name: "Seda Residences Makati",
    description:
      "Seda Residences Makati offers fully-equipped studios to three-bedroom serviced apartments. With unparalleled views from the Sky Lobby on the 19th floor to the roof deck bar on the 35th floor, it is right next to the casual dining options at Ayala North Exchange Mall and Greenbelt.",
    address:
      "Ayala Avenue Corner Amorsolo and Salcedo Streets, Legazpi Village, Makati City, 1229 Philippines",
    phone: "+632 7756 9288",
    email: "residencesmakati@sedahotels.com",
    promo: "#",
  },
  {
    logo: "/mini.png",
    name: "The Mini Suites",
    description:
      "The Mini Suites, located in the heart of Makati's business district, features 368 rooms with direct access to elevated walkways, providing convenient connections to shopping malls, embassies, a major hospital, a museum, and a variety of cafes and restaurants.",
    address: "128 Dela Rosa Street, Ayala South, Makati 1229. Philippines",
    phone: "+(632) 8868 6868",
    email: "stay@theminisuites.com",
    promo: "#",
  },
];
